import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import ExpandableParagraph from 'components/common/expandable_paragraph'
import Linkify from 'react-linkify'

const i18n = getI18n('components/campaign_details')

class CampaignDetails extends React.Component {
  static propTypes = {
    details: PropTypes.string,
  }

  render() {
    if (!this.props.details) {
      return null
    }

    return (
      <ExpandableParagraph titleText={i18n('title')}>
        <Linkify properties={{ target: '_blank' }}>
          {this.props.details}
        </Linkify>
      </ExpandableParagraph>
    )
  }
}

export default CampaignDetails
